import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getActivities } from '@/api/repository/activities';

export const useGetActivities = (
  id?: string,
  page?: number,
  refetchInterval?: boolean
) => {
  return useQuery({
    queryKey: ['getActivities', { id, page }],
    queryFn: () => getActivities(id, page || 1),
    enabled: !!id && !!page,
    retry: false,
    refetchInterval: refetchInterval ? 120000 : false,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};
